import api from './api';

const activityService = {
  // Listar atividades com filtros opcionais
  list: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.name) params.append('name', filters.name);
    if (filters.description) params.append('description', filters.description);
    if (filters.active !== undefined) params.append('active', filters.active);
    
    const response = await api.get(`/api/activities?${params.toString()}`);
    return response.data;
  },

  // Obter uma atividade específica
  get: async (id) => {
    const response = await api.get(`/api/activities/${id}`);
    return response.data;
  },

  // Criar nova atividade
  create: async (activityData) => {
    const response = await api.post('/api/activities', activityData);
    return response.data;
  },

  // Atualizar atividade existente
  update: async (id, activityData) => {
    const response = await api.put(`/api/activities/${id}`, activityData);
    return response.data;
  }
};

export default activityService;
